import { SprintMutationResult, useSprintMutation, useSprintQueryClient } from "sprint-common-web";

import { useAssetsApi } from "../../../../../common/api/master-api/assets/useAssetsApi";
import { OnPremAssetQueryKey } from "../../common/OnPremAssetQueryKey";

interface DeprecateOnPremAssetParams {
    assetId?: string;
}

export const useDeprecateOnPremAsset = ({
    invalidationKey
}: {
    invalidationKey?: string;
}): SprintMutationResult<DeprecateOnPremAssetParams> => {
    const { deprecateOnPremAsset } = useAssetsApi();
    const sprintQueryClient = useSprintQueryClient();

    return useSprintMutation<DeprecateOnPremAssetParams>({
        mutationFn: async ({ assetId }: DeprecateOnPremAssetParams) => {
            if (!assetId) {
                throw new Error("Asset ID is required to deprecate an on-prem asset.");
            }

            await deprecateOnPremAsset({ assetId });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [OnPremAssetQueryKey.OnPremAssetDetails, invalidationKey]
            });
        }
    });
};
